import React, { Component } from "react"
import { Container } from "reactstrap"

class Terms extends Component {
  render() {
    return (
      <React.Fragment>
        <div style={{ margin: "0 10% " }}>
          <Container fluid>
            <h4 class="text-center text-primary p-4">Terms and Conditions</h4>
            <p class="terms">
              <b>APT SKILLS SOFTWARE SERVICES PRIVATE LIMITED</b> operates a
              website
              <a href="ukiddiy.com" class="text-primary">
                www.ukiddiy.com
              </a>{" "}
              and mobile application “uKiddiy” ( the “App”) available on Google
              play store, Android platform. These Terms and Conditions govern
              the use of or access to the App and the services ( as described
              below). These Terms and Conditions constitute a binding and
              enforceable contract between
              <b>APT SKILLS SOFTWARE SERVICES PRIVATE LIMITED</b> and a user.
              You represent and warrant that you (a) have full legal capacity
              and authority to agree and bind yourself to these Terms and
              Conditions . (b) are 18(eighteen) years of age or older and (c)
              are Indian resident. These Terms and Conditions also include our
              Privacy Policy available at
              <a href="./privacy.html" class="text-primary">
                Privacy Policy.
              </a>
            </p>

            <p class="terms">
              By downloading or using the App, these Terms and Conditions will
              automatically apply to you – you should make sure therefore that
              you read them carefully before using the App. You’re not allowed
              to copy, or modify the App, any part of the App, or our trademarks
              in any way. You’re not allowed to attempt to extract the source
              code of the App, and you also should not try to translate the App
              into other languages, or make derivative versions. The App itself,
              and all the trade marks, copyright, database rights and other
              intellectual property rights related to it, still belong to APT
              SKILLS SOTWARE SERVICES PRIVATE LIMITED.
            </p>

            <p class="terms">
              APT SKILLS SOFTWARE SERVICES PRIVATE LIMITED is committed to
              ensuring that the App is as useful and efficient as possible. For
              that reason, we reserve the right to make changes to the App or to
              charge for its services, at any time and for any reason. We will
              never charge you for the App or its services without making it
              very clear to you exactly what you are paying for.
            </p>

            <p class="terms">
              The uKiddiy App stores and processes personal data that you have
              provided to us, in order to provide our Service. It’s your
              responsibility to keep your phone and access to the App secure. We
              therefore recommend that you do not jailbreak or root your phone,
              which is the process of removing software restrictions and
              limitations imposed by the official operating system of your
              device. It could make your phone vulnerable to
              malware/viruses/malicious programs, compromise your phone’s
              security features and it could mean that the uKiddiy App won’t
              work properly or at all.
            </p>

            <p class="terms">
              The App does use third party services that declare their own Terms
              and Conditions. Link to Terms and Conditions of third party
              service providers used by the App are Google Play Services and
              others.
            </p>

            <p class="terms">
              You should be aware that there are certain things that APT SKILLS
              SOFTWARE SERVICES PRIVATE LIMITED will not take responsibility.
              Certain functions of the App will require the App to have an
              active internet connection. The connection can be Wi-Fi, or
              provided by your mobile network provider, but APT SKILLS SOFTWARE
              SERVICES PRIVATE LIMITED cannot take responsibility for the App
              not working at full functionality if you don’t have access to
              Wi-Fi, and you don’t have any of your data allowance left.
            </p>

            <p class="terms">
              If you’re using the App outside of an area with Wi-Fi, you should
              remember that your terms of the agreement with your mobile network
              provider will still apply. As a result, you may be charged by your
              mobile provider for the cost of data for the duration of the
              connection while accessing the App, or other third party charges.
              In using the App, you are accepting responsibility for any such
              charges, including roaming data charges if you use the App outside
              of your home territory (i.e. region or country) without turning
              off data roaming. If you are not the bill payer for the device on
              which you’re using the App, please be aware that we assume that
              you have received permission from the bill payer for using the
              App.
            </p>

            <p class="terms">
              Along the same lines, APT SKILLS SOTWARE SERVICES PRIVATE LIMITED
              cannot always take responsibility for the way you use the App that
              is You need to make sure that your device stays charged – if it
              runs out of battery and you can’t turn it on to avail the Service,
              APT SKILLS SOTWARE SERVICES PRIVATE LIMITED cannot accept
              responsibility.
            </p>

            <p class="terms">
              With respect to APT SKILLS SOTWARE SERVICES PRIVATE LIMITED’s
              responsibility for your use of the App, when you are using the
              App, it’s important to bear in mind that although we endeavour to
              ensure that it is updated and correct at all times, we do rely on
              third parties to provide information to us so that we can make it
              available to you. APT SKILLS SOTWARE SERVICES PRIVATE LIMITED
              accepts no liability for any loss, direct or indirect, you
              experience as a result of relying wholly on this functionality of
              the App.
            </p>

            <p class="terms">
              At some point, we may wish to update the App. The App is currently
              available on Android – the requirements for system(and for any
              additional systems we decide to extend the availability of the App
              to) may change, and you’ll need to download the updates if you
              want to keep using the App. APT SKILLS SOTWARE SERVICES PRIVATE
              LIMITED does not promise that it will always update the App so
              that it is relevant to you and/or works with the Android version
              that you have installed on your device. However, you promise to
              always accept updates to the application when offered to you, We
              may also wish to stop providing the App, and may terminate use of
              it at any time without giving notice of termination to you. Unless
              we tell you otherwise, upon any termination, (a) the rights and
              licenses granted to you in these Terms and Conditions will end;
              (b) you must stop using the App, and (if needed) delete it from
              your device.
            </p>

            <p class="terms">
              <strong> Changes to This Terms and Conditions </strong>
            </p>

            <p class="terms">
              We may update our Terms and Conditions from time to time. Thus,
              you are advised to review this page periodically for any changes.
              We will notify you of any changes by posting the new Terms and
              Conditions on this page.
            </p>

            <p class="terms">
              These Terms and Conditions are effective as of 2021-11-23 Contact
              Us If you have any questions or suggestions about our Terms and
              Conditions, do not hesitate to contact us at
              <a href="mailto:info@ukiddiy.com" class="text-primary">
                info@ukiddiy.com
              </a>
            </p>
            <br />
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Terms
